export default "__VITE_ASSET__cxYiLxyF__"